'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TableRow", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: table-row;
  `
});
const TableRow = (props) => {
  return react.jsx("tr", { css: Styles.root, role: "row", "data-zds": true }, props.children);
};

exports.TableRow = TableRow;
//# sourceMappingURL=TableRow.cjs.js.map
